import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ConfirmDiscardDialog({ open, onConfirm, onCancel }) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{t('unsavedChanges.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('unsavedChanges.message')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="outlined">
          {t('unsavedChanges.stay')}
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          {t('unsavedChanges.discard')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
